import { Node, mergeAttributes, ReactNodeViewRenderer, NodeViewWrapper } from "@tiptap/react";

const attr = (name, def) => ({
  default: def,
  parseHTML: (el) => el.getAttribute(`data-${name}`) || "",
  renderHTML: (a) => ({ [`data-${name}`]: a[name] || "" }),
});

const Field = ({ label, value, onChange, testid, big }) => (
  <label className="block">
    <span className="text-[11px] font-bold uppercase tracking-widest text-violet-200">{label}</span>
    <input value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}
      className={`mt-1 w-full rounded-lg border border-white/15 bg-white/10 px-3 py-2 text-white placeholder:text-violet-300 ${big ? "text-lg font-extrabold" : "text-sm"}`} />
  </label>
);

const CtaView = ({ node, updateAttributes, deleteNode, selected }) => {
  const a = node.attrs;
  return (
    <NodeViewWrapper className={`my-8 rounded-[24px] bg-[#13052A] p-6 ${selected ? "ring-4 ring-[#7C3AED]" : ""}`} data-testid="editor-cta-block">
      <div contentEditable={false} className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-xs font-bold uppercase tracking-widest text-[#FF8A65]">Call-to-action block</span>
          <button type="button" onClick={deleteNode} className="text-xs font-bold text-violet-200 hover:text-white" data-testid="editor-cta-remove">Remove</button>
        </div>
        <Field label="Heading" big value={a.heading} onChange={(v) => updateAttributes({ heading: v })} testid="editor-cta-heading" />
        <Field label="Short text" value={a.text} onChange={(v) => updateAttributes({ text: v })} testid="editor-cta-text" />
        <div className="grid gap-3 sm:grid-cols-2">
          <Field label="Button label" value={a.label} onChange={(v) => updateAttributes({ label: v })} testid="editor-cta-label" />
          <Field label="Button link" value={a.href} onChange={(v) => updateAttributes({ href: v })} testid="editor-cta-href" />
        </div>
      </div>
    </NodeViewWrapper>
  );
};

export const CtaBlock = Node.create({
  name: "ctaBlock",
  group: "block",
  atom: true,
  draggable: true,
  addAttributes() {
    return { heading: attr("heading", "Ready to take the next step?"), text: attr("text", ""), label: attr("label", "Get a Free Digital Audit"), href: attr("href", "/contact?type=audit") };
  },
  parseHTML() { return [{ tag: "div[data-cta]" }]; },
  renderHTML({ HTMLAttributes }) { return ["div", mergeAttributes({ "data-cta": "" }, HTMLAttributes)]; },
  addNodeView() { return ReactNodeViewRenderer(CtaView); },
});
